import { Controller } from "@hotwired/stimulus";

// Creator-list modal form.
//
// The form just submits. CreatorListsController redirects back to whichever
// page you came from, Turbo follows it, and the page re-renders with the new
// name and icon.
//
// It used to intercept the submit and hand-roll a JSON fetch plus DOM patching
// so the modal could close without a reload. That bought an in-place update
// and cost a stuck spinner: application.js adds "loading search" to every
// submitted form.ui and only removes it on turbo:submit-end, which never fired
// because the interception stopped Turbo. The form stayed veiled, and the next
// time the modal opened it showed a dead spinner.
//
// All that's left is scrolling the current icon into view when the modal
// opens, so you can see what's selected in a long grid.
export default class extends Controller {
  connect() {
    this.modal = this.element.closest(".ui.modal");
    if (!this.modal) return;

    this.observer = new MutationObserver(() => {
      if (
        this.modal.classList.contains("visible") &&
        this.modal.classList.contains("active")
      ) {
        this.element
          .querySelector('[data-role="icon-option"].is-selected')
          ?.scrollIntoView?.({ block: "center", behavior: "instant" });
      }
    });
    this.observer.observe(this.modal, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  disconnect() {
    this.observer?.disconnect();
  }

  // The form targets the lists frame, so the panel refreshes on its own. All
  // that's left is dismissing the modal it was submitted from.
  saved(event) {
    if (event.detail?.success && window.jQuery) {
      window.jQuery(this.modal).modal("hide");
    }
  }
}
